<div fxLayout="column" fxLayoutAlign="center">
  <div fxFlex="300px" class='hero'></div>
  <div fxFlex="300px">

    <mat-card *ngIf="ulStats$ | async as stats" class="ul-stats-card">
      <mat-card-title>Statistiques de l'UL — {{stats.year}}</mat-card-title>
      <mat-card-content fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="0 grid">
        <b fxFlex="40">Montant total collecté</b>
        <span fxFlex="60">{{stats.amount | number:'1.0-0':'fr-FR'}} €</span>

        <b fxFlex="40">Dont carte bleue</b>
        <span fxFlex="60">{{stats.amount_cb | number:'1.0-0':'fr-FR'}} €</span>

        <b fxFlex="40">Objectif de l'année</b>
        <span fxFlex="60">
          {{stats.amount_year_objective | number:'1.0-0':'fr-FR'}} €
          <ng-container *ngIf="stats.amount_year_objective > 0">
            ({{(stats.amount / stats.amount_year_objective) | percent:'1.0-1'}})
          </ng-container>
        </span>

        <b fxFlex="40">Jours de quête</b>
        <span fxFlex="60">{{stats.number_of_days_quete}}</span>

        <b fxFlex="40">Points de quête utilisés</b>
        <span fxFlex="60">{{stats.number_of_point_quete}} / {{stats.total_number_of_point_quete}}</span>

        <b fxFlex="40">Troncs quêtés</b>
        <span fxFlex="60">{{stats.number_of_tronc_queteur}}</span>

        <b fxFlex="40">Temps passé à quêter</b>
        <span fxFlex="60">{{stats.time_spent_in_minutes | time}}</span>

        <b fxFlex="40">Poids total collecté</b>
        <span fxFlex="60">{{stats.weight | weight}}</span>
      </mat-card-content>
    </mat-card>



  </div>
  <div fxLayout="row wrap" fxLayoutAlign="center" fxLayoutGap="50px grid">
    <div *ngFor="let link of links" [routerLink]="[link.route]" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px"
      class="lien">
      <button mat-fab color="warn">
        <mat-icon>{{link.icon}}</mat-icon>
      </button>
      <h2>{{link.label}}</h2>
    </div>
  </div>
</div>
